import { render, staticRenderFns } from "./CodigoPageTitle.vue?vue&type=template&id=8308ec7a&"
import script from "./CodigoPageTitle.vue?vue&type=script&lang=ts&"
export * from "./CodigoPageTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports